// extracted by mini-css-extract-plugin
export default {"wrap":"Os-z","fullWidth":"Ps-z","items":"Qs-z","featureCss":"Rs-z","disabled":"Ss-z","imgCss":"Ts-z"};